import { render, staticRenderFns } from "./emptyData.vue?vue&type=template&id=9d7aa90a&scoped=true"
var script = {}
import style0 from "./emptyData.vue?vue&type=style&index=0&id=9d7aa90a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7aa90a",
  null
  
)

export default component.exports